module.exports = __webpack_public_path__ + "bb66ad42a77e30f4d4ea7bf7db8ff1b1.svg";